import { z } from 'zod';

/** Every API response wraps its payload in `data`, next to the request `status` and an optional `message`. */
export const apiResponseSchema = z.looseObject({
    status: z.number().optional(),
    message: z.string().nullish(),
    data: z.unknown(),
});

export const idSchema = z.union([z.number(), z.string()]);

// Missing or null texts come out as undefined, matching the `tag?: string` the screens declare.
export const optionalTextSchema = z
    .string()
    .nullish()
    .transform((value) => value ?? undefined);

// Texts a screen renders or compares directly come out as '' when missing.
export const requiredTextSchema = z
    .string()
    .nullable()
    .default('')
    .transform((value) => value ?? '');

// Totals for the table paging, accepted as text too, as database counts often are.
export const totalSchema = z
    .union([z.number(), z.string()])
    .nullish()
    .transform((total) => Number(total ?? 0));

/** Option lists whose screens read different fields per list: only the id is pinned, the rest passes through as sent. */
export const idOptionsSchema = z.array(z.looseObject({ id: idSchema }));

/** Option lists the screens show by name. */
export const namedOptionsSchema = z.array(z.looseObject({ id: idSchema, name: requiredTextSchema }));

/** Files downloaded with `responseType: 'arraybuffer'`. */
export const binaryFileSchema = z.instanceof(ArrayBuffer);
